
import { useState } from 'react';

export default function ContactForm() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
    subscribe: false,
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value, type } = e.target;
    const checked = (e.target as HTMLInputElement).checked;
    
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const formBody = new URLSearchParams();
      formBody.append('name', formData.name);
      formBody.append('email', formData.email);
      formBody.append('message', formData.message);
      formBody.append('subscribe', formData.subscribe.toString());

      const response = await fetch('https://readdy.ai/api/form/d5sl2786qf5t6pbjhoig', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString(),
      });

      if (response.ok) {
        setShowSuccess(true);
        setFormData({
          name: '',
          email: '',
          message: '',
          subscribe: false,
        });
        setTimeout(() => setShowSuccess(false), 5000);
      }
    } catch (error) {
      console.error('Form submission error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-12">
          <div className="md:col-span-2">
            <p className="text-amber-600 text-sm font-medium tracking-wider uppercase mb-3">Free Estimate</p>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
              Get a Quote
            </h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              Are you curious as to how much our services are going to cost?
              <br /><br />
              To receive a free painting service estimate, simply fill out the form and we will be in touch with you as soon as possible.
            </p>
          </div>

          <div className="md:col-span-3">
            <form
              id="contact-form"
              data-readdy-form
              onSubmit={handleSubmit}
              className="space-y-6"
            >
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-800 mb-2">
                  Your Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-beige-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent outline-none transition-all text-sm"
                  placeholder="Enter your name"
                />
              </div>

              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-800 mb-2">
                  Your email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-beige-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent outline-none transition-all text-sm"
                  placeholder="Enter your email"
                />
              </div>

              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-800 mb-2">
                  Your message
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  maxLength={500}
                  rows={5}
                  className="w-full px-4 py-3 border border-beige-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent outline-none transition-all resize-none text-sm"
                  placeholder="Tell us about your project"
                ></textarea>
                <p className="text-xs text-gray-500 mt-1">
                  Maximum 500 characters
                </p>
              </div>

              <div>
                <label className="flex items-start gap-3 cursor-pointer">
                  <input
                    type="checkbox"
                    name="subscribe"
                    checked={formData.subscribe}
                    onChange={handleChange}
                    className="mt-1 w-4 h-4 text-amber-500 border-beige-300 rounded focus:ring-amber-500 cursor-pointer"
                  />
                  <span className="text-xs text-gray-600 leading-relaxed">
                    By checking this box and submitting your information, you are granting us permission to email you. You may unsubscribe at any time.
                  </span>
                </label>
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full md:w-auto px-8 py-3 bg-amber-600 hover:bg-amber-700 disabled:bg-gray-400 text-white font-medium rounded-lg transition-colors duration-300 whitespace-nowrap cursor-pointer"
              >
                {isSubmitting ? 'Sending...' : 'Send Message'}
              </button>
            </form>

            {showSuccess && (
              <div className="mt-6 p-6 bg-beige-50 border border-beige-200 rounded-lg">
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                    <i className="fas fa-check-circle text-2xl text-amber-600"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-800 mb-2">Message Sent!</h3>
                    <p className="text-sm text-gray-600">
                      Your message has been sent successfully, I hope to respond within 24 hours. You can also contact us through social media @ Brushour, via WhatsApp or text message on 07595037441.
                      <br />
                      Thank you
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="mt-12 pt-12 border-t border-beige-200">
          <p className="text-sm text-gray-600 mb-4 text-center">
            <strong>Leave us a review!</strong> Share your experience with Brushour on our review platforms.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <a
              href="https://www.google.com/search?q=brushour+painters+and+decorators"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 px-6 py-3 bg-white border border-beige-200 hover:border-amber-500 rounded-lg transition-colors duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="fab fa-google text-xl text-red-600"></i>
              <span className="text-sm font-medium text-gray-800">Review on Google</span>
            </a>
            <a
              href="https://www.trustpilot.com/review/brushour.com"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 px-6 py-3 bg-white border border-beige-200 hover:border-amber-500 rounded-lg transition-colors duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="fas fa-star text-xl text-green-600"></i>
              <span className="text-sm font-medium text-gray-800">Review on Trustpilot</span>
            </a>
            <a
              href="https://www.facebook.com/brushour"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 px-6 py-3 bg-white border border-beige-200 hover:border-amber-500 rounded-lg transition-colors duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="fab fa-facebook text-xl text-sky-600"></i>
              <span className="text-sm font-medium text-gray-800">Review on Facebook</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
